<template>
  <div class="historyCont flex-col blur" :class="historySide ? 'show' : ''">
    <div class="flex-ac flex-end" style="margin-bottom: 16px">
      <img src="@/assets/img/Union@2x.png" alt="" style="height: 16px" class="pointer" @click="sideBtn(!historySide)" />
    </div>
    <div class="newChatBtn flex-ac flex-c pointer" @click="listClick(null)">
      <img src="@/assets/img/newChatBtn.png" alt="" />
      <span>创建新对话</span>
    </div>
    <div class="history flex1 scroll flex-col flex-start" @scroll="checkScrollBottom" ref="historyList">
      <EmptyCont text="暂无对话历史" v-if="!list.length" />
      <div class="list" v-for="(it, i) in list" :key="it.chatUuid"
        :style="{ marginTop: i && showGmtCreate(i) ? '16px' : '' }">
        <i v-html="showGmtCreate(i)" />
        <div class="flex-ac flex-start pointer" :class="it.chatUuid == chatUuid ? 'active' : ''">
          <p @click="listClick(it)">{{ it.chatName }}</p>
          <el-popover placement="right" popper-class="userPopper" transition="userPopper" :trigger="'click'">
            <div v-for="(act, i) in chatBtns" :key="i" class="flex-ac flex-start actionBtns pointer"
              @click="actionBtnsFunc(act, it)">
              <img :src="act.icon" alt="" />
              <span :style="{ color: act.color }">{{ act.text }}</span>
            </div>
            <template #reference>
              <img src="@/assets/img/Frame@2x (5).png" alt="" style="width: 12px" class="pointer" />
            </template>
          </el-popover>
        </div>
      </div>
      <div class="flex-ac flex-c" style="line-height: 20px;font-size: 12px;color: #999999;" v-show="!loading&list.length&&list.length==listTotal">已加载全部</div>
    </div>
    <!-- <LoadingCont v-show="loading" /> -->
    <div class="userCont flex-ac flex-sb">
      <img src="@/assets/img/Frame@2x (4).png" alt="" style="width: 20px" />
      <span class="flex1">{{ userLoginInfo?.username }}</span>
      <el-popover placement="top" popper-class="userPopper" transition="userPopper">
        <div v-for="(act, i) in userBtns" :key="i" class="flex-ac flex-start actionBtns pointer"
          @click="actionBtnsFunc(act)">
          <img :src="act.icon" alt="" />
          <span>{{ act.text }}</span>
        </div>
        <template #reference>
          <img src="@/assets/img/Frame@2x (5).png" alt="" style="width: 12px" class="pointer" />
        </template>
      </el-popover>
    </div>
  </div>
  <div class="historyShow pointer" @click="sideBtn(!historySide)" :class="historySide ? '' : 'show'">
    <img src="@/assets/img/Union@2x.png" alt="" />
  </div>
  <el-dialog  :append-to-body="true"align-center v-model="dialogVisible_rename" v-if="dialogVisible_rename" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="dialogTitle">对话重命名</div>
    <el-form :label-position="'right'">
      <el-form-item label="原名称">
        {{ oldChatName }}
      </el-form-item>
      <el-form-item label="新名称">
        <el-input clearable v-model="newChatName" style="width:300px" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible_rename = false">取消</el-button>
        <el-button type="primary" @click="renameFunc()"> 确认保存 </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import {
  ref,
  computed,
  onMounted,
  onBeforeMount,
  onBeforeUnmount,
  watch,
  getCurrentInstance,
} from "vue";
import chat from "@/api/chat.js";
import { useRouter } from "vue-router";
const router = useRouter();

import { storeToRefs } from "pinia";
import { useStore } from "@/store";
const store = useStore();
const { theme, userLoginInfo, chatUuid, historySide } = storeToRefs(store);
const { setChatUuid, setUserLoginInfo, setHistorySide } = store;

const { $formatDate } = getCurrentInstance().appContext.config.globalProperties;
import { ElMessage, ElMessageBox } from 'element-plus'
const dialogVisible_rename = ref(false);
const newChatName = ref('');
const oldChatName = ref('');

const userBtns = ref([
  {
    icon: require('@/assets/img/usetBtns_setting.png'),
    text: '设置',
  },
  {
    icon: require('@/assets/img/userBtns_service.png'),
    text: '联系客服',
  },
  {
    icon: require('@/assets/img/userBtns_logout.png'),
    text: '退出登录',
  },
])
const chatBtns = ref([
  {
    icon: require('@/assets/img/rename.png'),
    text: '重命名',
  },
  {
    icon: require('@/assets/img/delete.png'),
    text: '删除对话',
    color: '#E85A5A'
  },
])

const list = ref([]);
const listTotal = ref(0);
const current = ref(1);
const loading = ref(false);
const sideBtn = (v) => {
  setHistorySide(v);
}
watch(chatUuid, (v) => {
  searchPage('clear')
});
onBeforeMount(() => {
  searchPage();
});
const listClick = (it) => {
  if (!it) {
    router.push({ name: "home" });
  } else {
    setChatUuid(it.chatUuid);
    router.push({ name: "chat" });
  }
};
const searchPage = async (action) => {
  if (!userLoginInfo.value) return;
  loading.value = true;
  const res = await chat
    .searchPage({
      "current": current.value,
      "pageSize": 20,
      "keyword": ""
    })
  if (res.data) {
    loading.value = false;
    if (res.data.records && res.data.records.length) {
      res.data.records.map((v) => {
        v.historyBtnsShow = false;
      });
      if (action == 'clear') {
        list.value = res.data.records
      } else {
        list.value = [...list.value, ...res.data.records];
      }
      listTotal.value = res.data.total;
    }
  }
};

const historyList = ref(null);
const checkScrollBottom = (e) => {
  if (loading.value || (list.value.length >= listTotal.value)) {
    return;
  }
  if (historyList.value) {
    if (historyList.value.scrollTop + historyList.value.clientHeight >= historyList.value.scrollHeight) {
      current.value++;
      searchPage();
    }
  }
}

const showGmtCreate = (i) => {
  return i === 0 ||
    $formatDate(list.value[i].gmtCreate, "yyyy/MM/dd") !==
    $formatDate(list.value[i - 1].gmtCreate, "yyyy/MM/dd")
    ? $formatDate(list.value[i].gmtCreate, "yyyy/MM/dd")
    : "";
};

const actionBtnsFunc = (action, it) => {
  if (action.text == '设置') { }
  if (action.text == '联系客服') { }
  if (action.text == '退出登录') {
    ElMessageBox.confirm('确定退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      callback: (action) => {
        if (action == 'confirm') {
          setUserLoginInfo(null);
          localStorage.removeItem("userToken");
          localStorage.removeItem("loginUser");
          router.push({ name: "home" });
          ElMessage.success("退出登录成功");
        }
      },
    })
  }
  if (action.text == '删除对话') {
    ElMessageBox.confirm('确定删除对话吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      callback: (action) => {
        if (action == 'confirm') {
          chat.delete({ chatUuid: it.chatUuid }).then((res) => {
            if (res.success) {
              ElMessage.success("删除对话成功");
              searchPage('clear')
            }
          })
        }
      },
    })
  }
  if (action.text == '重命名') {
    oldChatName.value = it.chatName;
    newChatName.value = ''
    setChatUuid(it.chatUuid);
    dialogVisible_rename.value = true;
  }
}
const renameFunc = () => {
  if (!newChatName.value.trim()) {
    ElMessage.info("请输入新昵称");
    return;
  }
  chat
    .update({ chatUuid: chatUuid.value, chatName: newChatName.value }).then((res) => {
      if (res.success) {
        ElMessage.success("重命名成功");
        dialogVisible_rename.value = false;
        searchPage('clear')
      }
    })
}
</script>
<style lang="scss">
.historyCont {
  width: 230px;
  height: calc(100vh - 66px - 32px);
  position: fixed;
  top: calc(66px + 16px);
  left: calc(-16px - 16px - 230px);
  background: rgba(246, 246, 246, 0.75);
  box-shadow: 0px 2px 4px 0px rgba(0, 14, 67, 0.06);
  border-radius: 16px 16px 16px 16px;
  z-index: 67;
  padding: 16px;
}

.historyShow {
  position: fixed;
  z-index: 66;
  background: rgba(246, 246, 246, 0.75);
  box-shadow: 0px 2px 4px 0px rgba(0, 14, 67, 0.06);
  border-radius: 16px 16px 16px 16px;
  padding: 16px;
  width: 48px;
  height: 48px;
  top: calc(66px + 16px);
  left: calc(-16px - 16px - 230px);

  img {
    width: 16px;
  }
}

.historyCont.show {
  left: 16px;
}

.historyShow.show {
  left: 16px;
}

.newChatBtn {
  width: 100%;
  height: 36px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #707591;

  img {
    width: 16px;
  }

  span {
    font-family: PingFang SC, PingFang SC;
    font-size: 12px;
    color: #707591;
    margin-left: 6px;
  }
}

.userCont {
  border-top: 1px solid #e8edf3;
  padding-top: 16px;
  margin-top: 16px;

  span {
    height: 17px;
    font-size: 12px;
    color: #333333;
    margin: 0 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.history {
  padding: 16px 0 0;

  .list {
    i {
      font-size: 10px;
      color: #b0b3c8;
      text-indent: 8px;
      display: block;
    }

    p {
      width: calc(100% - 28px);
      font-size: 12px;
      color: #333333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 8px;
      line-height: 32px;
      text-indent: 8px;
    }

    img {
      display: none;
    }

    >div:hover {
      background: #ECEEF2;
      border-radius: 8px 8px 8px 8px;

      img {
        display: block;
      }
    }

  }

  .active {
    background: #ECEEF2;
    border-radius: 8px 8px 8px 8px;
  }
}

.list+.list {
  margin-top: 2px;
}
</style>
<style lang="scss">
.userPopper {
  width: 118px !important;
  min-width: 118px !important;
  background: #FFFFFF !important;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px 8px 8px 8px !important;
  padding: 0 4px !important;


  span {
    font-size: 12px;
    color: #333333;
    line-height: 12px;
  }

  img {
    width: 12px;
    margin-right: 8px;

  }

  .actionBtns {
    width: 110px;
    border-radius: 6px 6px 6px 6px;
    padding: 10px 14px;

    &:hover {
      background: #F8FBFF;
    }
  }
}
</style>